<div class="position-relative bg">
    <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
        <div class="row pt-10 pb-2 ml-3 ml-lg-7">
            <h1>Supporting our Porters</h1>
        </div>
        <div class="container space-bottom-2 px-lg-7">
            <div class="row my-4">
                <div class="col-12 col-lg-9 p-3 transparent-card">
                    <p class="mainBody">
                        Porters serve a vital role in your trip to Tanzania. These men and women work hard to ensure an
                        easy,
                        comfortable and enjoyable experience for you. Unfortunately, throughout history porters have not
                        always
                        received the compensation, safe working environment and gratitude that is beyond deserved. Kopa Tours is dedicated to
                        working with
                        the Mount Kilimanjaro Porters Society to help correct this wrong.
                    </p>
                    <br/>
                    <h3 class="porterHeader">Off the Mountain</h3>
                    <br/>
                    <p class="mainBody">The Mount Kilimanjaro Porters Society aims to improve porters’ lives both on and
                        off the mountain.
                        The society assists porters with financial management. After a trek has been completed, the
                        tips are counted, divided equally amongst all porters and then placed into their personal bank
                        account that
                        the society assisted in opening. This ensures a secured method of storage for their finances and
                        allows direct,
                        safe access to their salary as well. The Porters society also assists porters with financing
                        English classes
                        if they wish. English classes open up many opportunities to our porters. Through these English
                        classes, many
                        porters can advance their careers by becoming chefs, assistant guides and eventually head
                        guides. Outside of
                        financial guidance, the society also educates porters on how to live a healthy, safe lifestyle
                        through
                        personal health education courses. These courses provide education on how to protect themselves
                        from diseases
                        such as Malaria and HIV/AIDS.</p>
                    <br/>
                    <h3 class="porterHeader">On the Mountain</h3>
                    <br/>
                    <p class="mainBody">
                        Health and safety are of utmost importance for the porters. As porters are key to your climbing
                        success
                        and are in charge of carrying the bulk of the weight up the mountain, it is imperative that they
                        are well looked after.
                        We require that all your baggage be at or below 30 lbs. This is for the safety of our porters,
                        so that they do not
                        overexert themselves on top of their already physically demanding job. In addition, our porters
                        sleep in the same
                        tents as you, and are provided the same nutritious meals alongside you. Sleep and sufficient
                        food is essential while
                        spending days on end on the mountain. When porters are climbing, the Mount Kilimanjaro Porters
                        Society ensures that
                        the porters are going up the mountain in proper gear. This means warm clothes, climbing shoes,
                        hats, sleeping bags
                        etc. are provided. While on the job, the society secures the safety of thousands of porters each
                        and every day as
                        they make another journey up the beautiful Mount Kilimanjaro.
                    </p>
                    <br>
                    <div class="container img-cont">
                        <img appWidth=1900 appHeight=1263 appLazyload="others/porter-climbing-barranco-wall.jpg"
                             alt="Porters climb the Barranco Wall"/>
                    </div>
                    <br>
                    <p class="mainBody">
                        Our porters have a passion in working in tourism, and Mount Kilimanjaro Porters
                        Society helps them thrive safely both within their careers in tourism and their lives outside of
                        work.
                    </p>
                    <br/>
                    <p class="mainBody">
                        Read more about <a class="link pageLink" routerLink="/helpful-information/about-us" fragment="whybook"><u>our values</u></a>!
                    </p>
                </div>
                <div class="col-12 col-sm-8 col-lg-3 mx-auto mt-3 mb-7 mb-sm-0">
                    <div class="position-sticky" style="top: 20px;">
                        <img appWidth=640 appHeight=800 appLazyload="640x800/porter-society-logo.jpg"
                             alt="Mount Kilimanjaro Porters Society Logo" style="width:100%;max-width:360px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
